/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ICommonDialogData } from './models/type';

@Component({
  selector: 'viavi-common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrls: ['./common-dialog.component.scss']
})
export class CommonDialogComponent implements OnInit {
  isLoading: boolean;
  loaderMessage: string;
  isRequestFailed: boolean;
  message: string;
  errorDescription: string;
  icon: string;
  okText: string;
  cancelText: string;
  OnButtonClick = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<CommonDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: ICommonDialogData
  ) {
    if (data) {
      this.updateData(data);
    }
  }

  ngOnInit(): void {
    this.isLoading = false;
  }

  updateData(data: ICommonDialogData): void {
    this.isLoading = data.isLoading;
    this.loaderMessage = data.loaderMessage;
    this.message = data.message;
    this.errorDescription = data.errorDescription;
    this.icon = data.icon;
    this.isRequestFailed = data.isRequestFailed;
    this.okText = data.okText;
    this.cancelText = data.cancelText;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onButtonClick(): void {
    this.OnButtonClick.emit(this.data);
  }
}
